import { render, staticRenderFns } from "./ProfileTabsFive.vue?vue&type=template&id=0ae4a928&scoped=true&"
import script from "./ProfileTabsFive.vue?vue&type=script&lang=js&"
export * from "./ProfileTabsFive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae4a928",
  null
  
)

export default component.exports